<template>
  <div>
    <div class="offlineExam">
      <b-container fluid v-if="!enableManageQuestionWindow">
        <div class="loading" v-if="fetchData">
          <load-data></load-data>
        </div>
        <b-row v-else>
          <b-col md="12">
            <b-modal id="deleteQuestion" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer centered
              hide-header size="md">
              <p class="text-danger" style="font-size: 16px; font-weight: 600; text-align: center">
                Deleting this question will also delete the choices, answer,
                attachment, score, and the question-co mapping. Please click on
                continue to proceed. ?
              </p>
              <div class="buttons d-flex justify-content-between">
                <b-button variant="primary" size="sm" @click="deleteQuestion()">Continue</b-button>
                <b-button variant="danger" size="sm" @click="$bvModal.hide('deleteQuestion')">Cancel</b-button>
              </div>
            </b-modal>
            <!-- <b-form-checkbox v-model="importFromExcel">Import From Excel Sheet</b-form-checkbox> -->
            <!-- <ImportFromExcelTypeTwo :exam="exam" :courseModulesOptions="courseModulesOptions"
              :courseoutcomesOptions="courseoutcomesOptions" :bloomTaxonomyOptions="bloomTaxonomyOptions"
              :students="students" v-if="importFromExcel" @importedFromExcel="importedFromExcel" /> -->
            <div>
              <!-- toggle other sections teaching the same course code in/out of this activity -->
              <b-row :class="'m-2 mb-2 pb-2 border-bottom border-info'" v-if="sectionCheckboxOptions.length > 0">
                <b-col cols="3">Sections in this activity:</b-col>
                <b-col>
                  <b-form-checkbox-group
                    v-model="selectedSectionIds"
                    :options="sectionCheckboxOptions"
                    :disabled="sectionActionInProgress"
                    @change="onSectionSelectionChange"
                    stacked
                    name="activity-sections">
                  </b-form-checkbox-group>
                </b-col>
              </b-row>
              <b-form @submit.prevent="saveQuestionsAndScores(false)" class="border-0">
                <!-- <div class="w-100 d-flex justify-content-between mb-3"> -->
                <b-row class="mb-2">
                  <b-col v-if="exam.offline_activity && !isTotalMark">
                    <b-button variant="primary" size="md" pill @click="openManageQuestionWindow()">Add/Edit
                      Question</b-button>
                  </b-col>
                  <b-col v-if="exam.is_objective_only">
                    Generate objective answer score <span class="text-danger" v-if="autoEvaluationStatus">Please wait...
                    </span>
                    <b-button v-else variant="primary" size="md" pill @click="genarateObjectiveScore()">Proceed
                    </b-button>
                  </b-col>
                  <b-modal id="importExcelModel" size="lg" v-model="viewImportExcelModel" title="Import excel for score"
                    hide-footer>
                    <div>
                      <b-form-file v-if="!importExcelFile" v-model="importExcelFile" accept=".xlsx" size="sm"
                        @change="importScoreExcel" placeholder="Choose an excel file or drop it here..."
                        drop-placeholder="Drop file here...">
                      </b-form-file>
                      <span v-if="importExcelFile" class="text-text-danger">{{ excelImportStatus }}</span>
                    </div>

                    <div>
                      <p style="font-size: 14px; font-weight: 600">Scores Excel Sheet</p>
                      <h6 style="font-size: 14px; font-weight: 900">
                        Note: Please do not include headings in the spreadsheet used to import data.
                        Enter only the values.
                      </h6>

                      <p>Sample excel format to import marks</p>
                      <img src="../../../../../assets/images/scores.png" alt="" class="img-fluid mx-auto d-block" />
                      <br>
                      <p>The imported data will look like this</p>
                      <img style="height: 250px;width: 400px;"
                        src="../../../../../assets/images/activityscoreimportoutput.png" alt=""
                        class="img-fluid mx-auto d-block" />
                    </div>
                  </b-modal>
                  <b-col class="text-left" v-if="!isTotalMark">
                    <b-button class="mb-2" variant="primary" v-b-modal.importExcelModel>Import excel</b-button>
                    <!-- <b-form-file v-if="!importExcelFile" v-model="importExcelFile" accept=".xlsx" size="sm"
                      @change="importScoreExcel" placeholder="Choose an excel file or drop it here..."
                      drop-placeholder="Drop file here...">
                    </b-form-file>
                    <span v-if="importExcelFile" class="text-text-danger">{{ excelImportStatus }}</span> -->
                  </b-col>
                  <b-col class="text-left">
                    <b-button class="mb-2" @click="prepareExport()" variant="primary">Export to Excel</b-button>
                  </b-col>
                  <b-col class="text-right">
                    <b-button :disabled="saveBtn.disabled || questions.length == 0" variant="success"
                      @click="saveAndPublishResult()" size="md" pill>
                      {{ saveBtn.disabled ? saveBtn.text : 'Save & Send SMS' }}
                    </b-button>
                  </b-col>
                  <b-col class="text-right">
                    <b-button :disabled="saveBtn.disabled || questions.length == 0" variant="success" type="Submit"
                      size="md" pill>{{ saveBtn.text }}</b-button>
                  </b-col>

                  <!-- <b-col>

                    <div class="closeBtn mb-2 text-right">
                      <span v-if="exam_id == null" @click="closeCurrentTab()" class="btn m-0">
                        <i class="fas fa-window-close fa-4x text-danger"></i>
                      </span>
                      <span v-else @click="$root.clearSubContent" class="btn m-0">
                        <i class="fas fa-window-close fa-4x text-danger"></i>
                      </span>
                    </div>
                  </b-col> -->

                </b-row>
                <!-- </div> -->
                <b-overlay :show="loadExams" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
                  <div class=" " style="height: 80vh !important;">
                    <table class="table table-bordered table-striped" id="institutionUserDetails">
                      <thead class="thead-dark" style="font-size: 14px; font-weight: 600">
                        <tr style="z-index: 100; position: sticky; top: 0px;">
                          <th>
                            <span v-for="(vHeader, vHeaderIndex) in viewHeader" :key="vHeaderIndex">
                              <i v-if="!vHeader" @click="viewHeader[vHeaderIndex] = true" class="fas fa-eye"></i>
                            </span>
                          </th>
                          <th></th>
                          <th>{{ isTotalMark ? "" : "Question" }}</th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <div class="">
                              <span v-if="isTotalMark">Total Mark</span>
                              <span v-else-if="edit">{{
                                  question.question_no
                              }}</span>
                              <b-form-input :required="true" v-model="question.question_no" placeholder="Ques No."
                                v-else></b-form-input>
                              <br>

                              <!-- <span style="align-self: center" v-if="question.id != null"
                                class="text-danger btn p-0 m-0 ml-2" @click="checkDeleteQuestion(questionIndex)"><i
                                  class="fas fa-trash-alt"></i>
                                </span>

                              <span v-else style="align-self: center" class="text-danger btn p-0 m-0 ml-2"
                                @click="questions.splice(questionIndex, 1)"><i class="fas fa-minus-circle"></i></span> -->
                            </div>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr>
                        <tr v-if="viewHeader.maxMark">
                          <th>
                            <i @click="viewHeader.maxMark = !viewHeader.maxMark" :class="
                              viewHeader.maxMark
                                ? 'far fa-eye-slash'
                                : 'fas fa-eye'
                            "></i>
                          </th>
                          <th></th>
                          <th>Max Marks</th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <span v-if="edit || (exam.positive_mark != null)">{{ exam.positive_mark != null ?
                                `${exam.positive_mark} or ${exam.negative_mark}` : question.maximum_mark
                            }}</span>
                            <span v-else>
                              <!-- <span v-if="
                              question.orquestion_group_id != null &&
                              question.orquestion_group_id in
                              orquestiongroups">
                                {{ orquestiongroups[question.orquestion_group_id].maximum_mark_of_question }}
                              </span> -->
                              <b-form-input :required="true" @change="updateTotalQuestionScore"
                                v-model="question.maximum_mark" placeholder="Marks">
                              </b-form-input>
                            </span>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr>
                        <tr v-if="viewHeader.co">
                          <th>
                            <i @click="viewHeader.co = !viewHeader.co" :class="
                              viewHeader.co
                                ? 'far fa-eye-slash'
                                : 'fas fa-eye'
                            "></i>
                          </th>
                          <th></th>
                          <th>CO Mapping</th>

                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <span v-if="edit">
                              <span v-if="question.co_mapping.length == 0">-</span>
                              <span v-else v-for="(co, coIndex) in question.co_mapping" :key="coIndex">
                                {{ co.name }}
                                <span v-if="
                                  coIndex != question.co_mapping.length - 1
                                ">,</span>
                              </span>
                            </span>
                            <div v-else>
                              <multiselect v-model="question.co_mapping" :options="courseoutcomesOptions"
                                :multiple="true" :close-on-select="false" :clear-on-select="false"
                                placeholder="Select CO's" label="name" track-by="value" :preselect-first="false"
                                openDirection="bottom">
                                <template slot="selection"><span class="multiselect__single d-flex flex-wrap"
                                    v-if="question.co_mapping.length">
                                    <span v-for="(co,
                                    coIndex) in question.co_mapping" :key="coIndex">
                                      {{ co.name }} ,
                                    </span>
                                  </span></template>
                              </multiselect>
                            </div>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr>
                        <tr v-if="viewHeader.module && !isTotalMark">
                          <th>
                            <i @click="viewHeader.module = !viewHeader.module" :class="
                              viewHeader.module
                                ? 'far fa-eye-slash'
                                : 'fas fa-eye'
                            "></i>
                          </th>
                          <th></th>
                          <th>Module Mapping</th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <span v-if="edit">
                              <span v-if="question.module_id == null">-</span>
                              <span v-else>
                                {{
                                    courseModulesOptionsObject[question.module_id]
                                }}
                              </span>
                            </span>
                            <b-form-select v-else v-model="question.module_id" :options="courseModulesOptions">
                            </b-form-select>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr>
                        <tr v-if="viewHeader.blooms && !isTotalMark">
                          <th>
                            <i @click="viewHeader.blooms = !viewHeader.blooms" :class="
                              viewHeader.blooms
                                ? 'far fa-eye-slash'
                                : 'fas fa-eye'
                            "></i>
                          </th>
                          <th></th>
                          <th>Blooms Taxonomy</th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <span v-if="edit">
                              <span v-if="question.taxonomy == null">-</span>
                              <span v-else>
                                {{
                                    bloomTaxonomyOptionsObject[question.taxonomy]
                                }}
                              </span>
                            </span>
                            <b-form-select v-else v-model="question.taxonomy" :options="bloomTaxonomyOptions">
                            </b-form-select>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr>

                        <!-- <tr v-if="viewHeader.orq">
                          <th>
                            <i @click="viewHeader.orq = !viewHeader.orq" :class="
                              viewHeader.orq
                                ? 'far fa-eye-slash'
                                : 'fas fa-eye'
                            "></i>
                          </th>
                          <th>
                            OR question grouping
                            <b-button variant="info" class="text-white sm" size="sm"
                              @click="examorQuestiongroupmodel(true)">Add/edit</b-button>
                          </th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <select class="custom-select" v-model="question.orquestion_group_id">
                              <option :value="null">Select group</option>
                              <option v-for="(group, groupindex) in orquestiongroups" :key="groupindex"
                                :value="group.id" :selected="
                                  group.id == question.orquestion_group_id
                                ">{{ group.summary }}</option>
                            </select>
                          </th>
                          <th v-if="!isTotalMark"></th>
                          <th></th>
                        </tr> -->

                        <tr>
                          <th>{{ studentListOrder === 'enrollment_no' ? 'Enrollment No.' : studentListOrder === 'admission_number' ? 'Admission No.' : studentListOrder === 'register_number' ? 'Register No.' : 'Roll No.' }}</th>
                          <th>Absent</th>
                          <th>Name</th>
                          <th v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            {{ isTotalMark ? `Mark (${totalMarks})` : 'Score' }}
                          </th>
                          <th v-if="!isTotalMark">
                            Total Score
                            <small>({{ totalMarks }})</small>
                          </th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody style="border: 0px;" v-for="(student, studentIndex) in students" :key="studentIndex">
                        <tr v-if="hasMultipleSections && isNewSectionGroup(studentIndex)">
                          <td :colspan="questions.length + 5" class="bg-secondary text-white font-weight-bold text-center pl-2">
                            {{ student.section_label }}
                          </td>
                        </tr>
                        <tr style="font-size: 14px; font-weight: 600">
                          <td class="p-0">{{ studentListOrder === 'enrollment_no' ? student.enrollment_no : studentListOrder === 'admission_number' ? student.admission_no : studentListOrder === 'register_number' ? student.register_no : student.roll_number }}</td>
                          <td class="p-0"><b-checkbox switch :value="1" @change="clearAbsentStudentScores(student.id)"
                             v-model="student.absent_enable"></b-checkbox></td>
                          <td class="p-0 pl-1 text-left">
                            {{ student.first_name || " " }}
                            {{ student.last_name || " " }}
                            <br>
                            <div v-if="!exam.offline_activity">
                              <span v-if="expandedEvaluationStudId != student.id" style="align-self: center"
                                class="text-info btn p-0 m-0 ml-2" @click="viewStudEvaluation(student.id)"><i
                                  class="fas fa-search-plus"></i></span>
                              <span v-else style="align-self: center" class="text-success btn p-0 m-0 ml-2"
                                @click="expandedEvaluationStudId = null"><i class="fas fa-search-minus"></i></span>
                            </div>
                          </td>
                          <td v-for="(question, questionIndex) in evaluationQuestions" :key="questionIndex">
                            <span v-if="student.absent_enable" :style="{ position: 'relative', right: '90px' }">
                              ab
                            </span>
                            <span v-else>
                              <span v-if="edit">{{
                                  question.scores[student.id]
                              }}</span>
                              <b-form-input
                                style="max-width: 130px;"
                                :disabled="student.absent_enable || expandedEvaluationStudId == student.id"
                                v-model="question.scores[student.id]"
                                placeholder="Score"
                                :class="{ 'is-invalid': validateScoreInput(question, student.id), 'text-center': true }"
                                @blur="handleScoreEntry(question, student.id)"
                              >
                              </b-form-input>
                            </span>
                          </td>
                          <td class="align-middle text-center" v-if="!isTotalMark">
                            <span v-if="student.absent_enable">ab</span>
                            <span v-else>
                              <span v-if="edit">{{ updateTotalMarks[student.id] }}</span>
                              <span v-else>{{ updateTotalMarks[student.id] }}</span>
                            </span>
                          </td>
                          <td class="align-middle text-center">
                            <span v-if="student.absent_enable">
                                ab
                            </span>
                            <span v-else-if="updateTotalMarks[student.id]">
                              <span v-if="edit">{{
                                  Math.floor(
                                    (updateTotalMarks[student.id] / totalMarks) *
                                    100
                                  )
                              }}</span>
                              <span v-else>{{
                                   ((updateTotalMarks[student.id] / totalMarks) * 100).toFixed(2) + "%" 
                              }}</span>
                            </span>
                          </td>
                        </tr>
                        <tr v-if="expandedEvaluationStudId == student.id">
                          <td :colspan="questions.length + 4" class="p-1">
                            <StudentExamEvaluation @updateStudScore="updateStudentQuestionScoreFromEvaluation"
                              :student_id="student.id" :exam_id="exam.id" :exam="exam"
                              :activeStudentQuestionsScores="activeStudentQuestionsScores" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-overlay>
              </b-form>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <div v-else>
        <b-row> <b-col class="text-right mb-1"> <b-button variant="danger" @click="closeManageQuestionWindow">Return to
              Score Window</b-button> </b-col> </b-row>
        <ManageExamQuestions lazy :exam="exam" />
      </div>

      <!-- //orquestion group manage -->

      <!-- <b-modal v-if="enableOrQuestiongroupmodel" :id="'orQuestiongroupmodel'" no-close-on-backdrop no-close-on-keyboard
        no-close-on-esc hide-footer hide-header size="xl">
        <b-container>
          <b-row>
            <b-col style="text-align:right;">
              <b-button variant="danger" size="sm" @click="examorQuestiongroupmodel(false)">close</b-button>
            </b-col>
          </b-row>
          <br />
          <ExamorquestiongroupDash :exam_id="examId" />
        </b-container>
      </b-modal> -->
    </div>
  </div>
</template>

<script>
import { required, requiredIf, integer } from "vuelidate/lib/validators";
// import ImportFromExcelTypeTwo from "./ImportFromExcelTypeTwo.vue";
import StudentExamEvaluation from "./StudentExamEvaluation.vue";
// import ExamorquestiongroupDash from "../examorquestiongroup/dashboard.vue";
import ManageExamQuestions from "../manageExamQuestions.vue"
import XLSX from "xlsx";
import readXlsxFile from "read-excel-file";
export default {
  props: ['enableCo', 'enableTaxonomy', 'enableModule', 'enableOrQuestion', 'exam_id'],
  async created() {
    if (this.enableCo == false) this.viewHeader.co = false;
    if (this.enableTaxonomy == false) this.viewHeader.blooms = false;
    if (this.enableOrQuestion == false) this.viewHeader.orq = false;
    if (this.enableModule == false) this.viewHeader.module = false;
    this.fetchData = true;
    this.examId = this.exam_id;
    // if (!this.examId) this.examId = this.$route.params.exam_id;
    // await this.getExam();
    // if (this.exam.co_score_evaluation) {
    //   window.alert(
    //     'This option not avilable for Activity with "Evaluation by CO score" enabled'
    //   );
    //   return;
    // }
    await Promise.all([
      this.getExam(),
      this.getExamOrQuestionGroups(),
    ]);
    if (this.exam.positive_mark) this.viewHeader.maxMark = false;
    if (this.exam.is_objective_only) {
      this.viewHeader.co = false;
      this.viewHeader.blooms = false;
      this.viewHeader.orq = false;
      this.viewHeader.module = false;
    }
    // await this.getExamOrQuestionGroups();
    await this.fetchLinkedSections();
    this.selectedSectionIds = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
    await this.prepareTable();
    await this.getExamScores();
    await Promise.all([
      this.getCourseModules(),
      this.getCourseOutcomes(),
    ]);
    // await this.getCourseModules();
    // await this.getCourseOutcomes();
    await this.bloomTaxonomyOptions.forEach((bloom) => {
      this.$set(this.bloomTaxonomyOptionsObject, bloom.value, bloom.text);
    });
    this.fetchData = false;
    this.smsCount = this.$store.getters.getSmsCount.smsBalance;
  },
  components: {
    // ImportFromExcelTypeTwo,
    // ExamorquestiongroupDash,
    StudentExamEvaluation,
    ManageExamQuestions,
  },
  data() {
    return {
      smsCount: null,
      fetchData: false,
      loadExams: false,
      deleteQuestionIndex: null,
      examId: null,
      exam: {},
      questions: [],
      courseModulesOptions: [],
      courseoutcomesOptions: [],
      importFromExcel: false,
      bloomTaxonomyOptionsObject: {},
      bloomTaxonomyOptions: [
        {
          value: null,
          text: "Select Taxonomy",
          description: "",
          disabled: true,
        },
        {
          value: "6",
          text: "Creating",
          description: "User information to create something new",
        },
        {
          value: "5",
          text: "Evaluating",
          description: "Examine information and make judgement.",
        },
        {
          value: "4",
          text: "Analyzing",
          description: "Take apart from known and identify relationships.",
        },
        {
          value: "3",
          text: "Applying",
          description: "Use information in a new (but similar) situation.",
        },
        {
          value: "2",
          text: "Understanding",
          description: "Grasp meaning of instructional materials.",
        },
        {
          value: "1",
          text: "Remembering",
          description: "Recall specific facts.",
        },
      ],
      students: [],
      studentListOrder: 'roll_number',

      linkedSections: [], // sibling course sections (same code, same faculty, same semester) not yet attached to this activity
      selectedSectionIds: [], // course_ids currently checked (attached, excluding the primary course)
      sectionActionInProgress: false,

      saveBtn: {
        text: "Save",
        disabled: false,
      },
      totalScores: {}, // processed on updateTotalMarks computed proprty
      totalMarks: null, // processed on updateTotalQuestionScore method
      zIndex: -1,
      edit: false,
      courseModulesOptionsObject: {},
      orquestiongroups: {},
      orGroupQuestionIds: {}, // to calculate student totel score 
      // enableOrQuestiongroupmodel: false,
      viewHeader: {
        maxMark: true,
        co: true,
        module: true,
        blooms: true,
        orq: true,
      },
      importExcelFile: null,
      excelImportStatus: "",
      viewImportExcelModel: false,

      expandedEvaluationStudId: null,
      activeStudentQuestionsScores: {},//pass to child
      autoEvaluationStatus: false,
      enableManageQuestionWindow: false,

      subQuestionParentIds: [], // avoid enter score for main question of subquestions
      enteredScores: new Set(), // Store unique entries
    };
  },
  computed: {
    // true once this activity has been attached to more than one section
    hasMultipleSections() {
      return (this.exam.course || []).length > 1;
    },
    // the course this activity was originally created for; not itself toggleable
    primaryCourseId() {
      return (this.exam.course || [])[0] ? this.exam.course[0].id : null;
    },
    // checkbox options: sections already attached (besides the primary) + sections
    // available to add, so checking/unchecking either attaches or detaches
    sectionCheckboxOptions() {
      const attached = (this.exam.course || [])
        .filter(course => course.id !== this.primaryCourseId)
        .map(course => ({ value: course.id, text: course.usersubgroup.name }));
      const notAttached = this.linkedSections.map(section => ({ value: section.course_id, text: section.section_label }));
      return [...attached, ...notAttached];
    },
    isTotalMark() {
      return Number(this.exam.co_score_evaluation) === 2;
    },
    // question without main question of subquestions
    evaluationQuestions() {
      return this.questions.filter((q) => {
        return !this.subQuestionParentIds.includes(q.id);
      });
    },
    updateTotalMarks() {
      this.students.forEach((student) => {
        this.totalScores[student.id] = 0;
        this.questions.forEach((question) => {
          if (question.subquestion_parent_id == null && question.orquestion_group_id == null) { // process only normal main question 
            if (this.subQuestionParentIds.includes(question.id)) {
              let subs = this.questions.filter((q) => {
                return `${q.subquestion_parent_id}` == `${question.id}`;
              });
              subs.forEach(subq => {
                this.totalScores[student.id] += Number(subq.scores[student.id]) || 0;
              });
            } else {
              this.totalScores[student.id] += Number(question.scores[student.id]) || 0;
            }
          }
        });

        //if orquestions exist
        for (let gkey in this.orquestiongroups) {
          let group = this.orquestiongroups[gkey];
          let bestscores = [];
          let studentgroupScores = [];
          this.orGroupQuestionIds[group.id].forEach((qId) => {
            var questionObj = this.questions.find((obj) => {
              return obj.id == qId;
            });
            if (this.subQuestionParentIds.includes(questionObj.id)) {
              let subqs = this.questions.filter((q) => {
                return `${q.subquestion_parent_id}` == `${questionObj.id}`;
              });
              let subQuestionSum = 0;
              subqs.forEach(subq => {
                subQuestionSum += Number(subq.scores[student.id]) || 0;
              });
              studentgroupScores.push(subQuestionSum);
            } else {
              studentgroupScores.push(Number(questionObj.scores[student.id]) || 0);
            }
          });

          // sort and select best no. of scores
          studentgroupScores.sort(function (a, b) {
            return b - a;
          });
          bestscores = studentgroupScores.slice(0, group.best_of_questions);
          this.totalScores[student.id] += bestscores.reduce((a, b) => a + b, 0);
        }

      });

      return this.totalScores;
    },
  },
  validations: {
    questions: {
      required,
      $each: {
        question_no: {
          required,
        },
        maxMarks: {
          required: requiredIf(function () {
            return this.exam.positive_mark == null;
          }),
          integer,
        },
      },
    },
  },

  methods: {
    handleScoreEntry(question, studentId) {
      const key = `${question.id}-${studentId}`;
      this.enteredScores.add(key); 
      if(this.enteredScores.size >= 20){
        this.saveQuestionsAndScores(true); // autoUpdateEvent = true
        this.enteredScores= new Set(); // Store unique entries
      }
    },
    async clearAbsentStudentScores(student_id) {
      this.evaluationQuestions.forEach(q => {
        q.scores[student_id] = null;
      });
    },
    async saveAndPublishResult() {
      let confirmation = `WARNING: (Balance SMS Count: ${this.smsCount}), You are going to save and send SMS message to all parents with exam score.`;
      if (confirm(confirmation) !== true) {
        return false;
      }
      await this.saveQuestionsAndScores(false);
      this.saveBtn = { text: "sending SMS...", disabled: true };
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.examId}/publishresults`;
      await this.$axios.get(url).then(() => {
        this.$toast.success("Result published successfully", {
          position: "top",
          duration: 4000,
        });
      }).catch(() => {
        this.$toast.error("Failed to sent SMS to parents", {
          position: "top",
          duration: 10000,
        });
      });

      this.saveBtn = { text: "Save", disabled: false };
    },
    validateScoreInput(question, student_id) {
      if (question.scores[student_id] == null) return false;
      if (this.exam.positive_mark) {
        if ((this.exam.negative_mark != null) && (Number(question.scores[student_id]) == Number(this.exam.negative_mark))) return false;
        if (Number(question.scores[student_id]) == Number(this.exam.positive_mark) || Number(question.scores[student_id]) == 0) return false;
      }
      // else if (question.orquestion_group_id != null &&
      //   question.orquestion_group_id in
      //   this.orquestiongroups) {
      //   return Number(question.scores[student_id]) > Number(this.orquestiongroups[question.orquestion_group_id].maximum_mark_of_question);
      // } 
      else {
        return Number(question.scores[student_id]) > Number(question.maximum_mark);
      }
      return true;
    },
    updateStudentQuestionScoreFromEvaluation(data) {
      this.questions.forEach(q => {
        if (q.id == data.question_id) {
          q.scores[this.expandedEvaluationStudId] = data.score;
        }
      });
    },
    async viewStudEvaluation(studId) {
      await this.questions.forEach(q => {
        this.activeStudentQuestionsScores[q.id] = q.scores[studId];
      });
      this.expandedEvaluationStudId = studId;
    },

    async importScoreExcel(event) {
      this.excelImportStatus = 'importing in progress ....';
      let excelData = [];
      let error = false;
      // console.log(event.target.files[0]);
      await readXlsxFile(event.target.files[0]).then((data) => {
        excelData = data;
      }).catch(() => {
        error = true;
        this.$toast.error("Error: unsupported file. Please make sure the file extension is '.xlsx' / please check the file again", {
          position: "top",
          duration: 10000,
        });
      });
      // console.log(excelData);
      // console.log(excelData.length);
      // console.log(this.students.length);
      // console.log(excelData[0].length);
      // console.log(this.questions.length);

      if (excelData.length > this.students.length || excelData[0].length > this.evaluationQuestions.length) {
        this.$toast.error(`Error: Excel row count(${excelData.length}) and column count(${excelData[0].length}) should be less than or equal to students count(${this.students.length}) and questions count(${this.questions.length})`, {
          position: "top",
          duration: 10000,
        });
        error = true;
      }

      for (let row = 0; row < this.students.length; row++) {
        if (row >= excelData.length) { break; }
        // console.log('row', row);
        for (let col = 0; col < this.evaluationQuestions.length; col++) {
          if (col >= excelData[row].length) { break; }
          // console.log('col', col);
          if (isNaN(excelData[row][col]) && excelData[row][col] != null) {
            this.$toast.error(`Score in Row: ${row + 1}  Col: ${col + 1} (${excelData[row][col]}) is not a Number. or make it empty`, {
              position: "top",
              duration: 70000,
            });
            error = true;
            row = row + this.students.length;
            break;
          }
          this.evaluationQuestions[col].scores[this.students[row].id] = excelData[row][col];
        }
      }


      this.importExcelFile = null;

      this.$forceUpdate();
      if (!error) this.$toast.success("Imported successfully", {
        position: "top",
        duration: 3000,
      });
      this.viewImportExcelModel = false;
    },
    async prepareExport() {
      this.edit = true;
      this.loadExams = true;
      await setTimeout(() => {
        this.exportToExcel("xlsx");
        this.edit = false;
        this.loadExams = false;
      }, 3000);
    },
    async exportToExcel(type, fn, dl) {
      var elt = document.getElementById("institutionUserDetails");
      var wb = await XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      this.loadExams = false;

      dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "assessmentDetails." + (type || "xlsx"));
    },
    // checkDeleteQuestion(questionIndex) {
    //   this.deleteQuestionIndex = questionIndex;
    //   this.$bvModal.show("deleteQuestion");
    // },
    async importedFromExcel() {
      await this.getExamQuestions();
      await this.getExamScores();
      this.importFromExcel = false;
    },
    async getExam() {
      const url =
        this.$store.getters.getAPIKey.examination + `/${this.examId}`;
      await this.$axios.get(url).then((response) => {
        this.exam = response.data;
        this.exam.usergroup_id = this.exam.course[0].usersubgroup.usergroup.id;
        this.exam.config_group_id = this.exam.course[0].usersubgroup.programme_config_group_id;
      });
    },
    async prepareTable() {
      await this.getExamParticipants();
      if (this.isTotalMark) {
        this.applyTotalMarkQuestion();
        return;
      }
      await this.getExamQuestions();
      // this.$forceUpdate();
    },

    async fetchLinkedSections() {
      this.linkedSections = [];
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.examId}/linkedsections`;
      await this.$axios.get(url).then((response) => {
        this.linkedSections = response.data;
      }).catch((error) => {
        error;
      });
    },

    async attachLinkedSection(courseId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.examId}/attachcoursesection`;
      let success = false;
      await this.$axios.post(url, { course_id: courseId })
        .then(() => { success = true; })
        .catch((error) => {
          error;
          this.$toast.error('Failed to add section, please try again', { position: "top", duration: 5000 });
        });
      return success;
    },

    async detachLinkedSection(courseId) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.examId}/detachcoursesection`;
      let success = false;
      await this.$axios.post(url, { course_id: courseId })
        .then(() => { success = true; })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to remove section, please try again';
          this.$toast.error(message, { position: "top", duration: 7000 });
        });
      return success;
    },

    // v-model of the checkbox group has already flipped to the newly-checked state;
    // diff it against what's actually attached to figure out what to attach/detach
    async onSectionSelectionChange(newSelection) {
      this.sectionActionInProgress = true;
      const currentlyAttached = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
      const toAttach = newSelection.filter(courseId => !currentlyAttached.includes(courseId));
      const toDetach = currentlyAttached.filter(courseId => !newSelection.includes(courseId));

      for (const courseId of toAttach) {
        await this.attachLinkedSection(courseId);
      }
      for (const courseId of toDetach) {
        await this.detachLinkedSection(courseId);
      }

      await this.getExam(); // refreshes exam.course to reflect what actually attached/detached
      await this.fetchLinkedSections();
      await this.getExamParticipants();
      await this.getExamScores();
      // reconcile checkboxes with reality - a blocked detach snaps back to checked
      this.selectedSectionIds = this.exam.course.filter(course => course.id !== this.primaryCourseId).map(course => course.id);
      this.sectionActionInProgress = false;
    },

    // total mark entry keeps one total per student on the participant (exam.maximum_mark is the max),
    // shown here as a single virtual column so it never touches the question paper
    applyTotalMarkQuestion() {
      let scores = {};
      this.students.forEach((student) => {
        let score = student.pivot ? student.pivot.score : null;
        scores[student.id] =
          score != null
            ? score % 1 == 0
              ? Math.floor(score)
              : parseFloat(score).toFixed(2)
            : null;
      });
      let maximumMark = this.exam.maximum_mark;
      if (maximumMark != null && maximumMark % 1 == 0) maximumMark = Math.floor(maximumMark);
      this.questions = [{
        id: "total",
        question_no: "Total",
        name: null,
        maximum_mark: maximumMark,
        // CO ids, turned into select options by getCourseOutcomes
        co_mapping: [...((this.exam.settings && this.exam.settings.total_mark_course_outcomes) || [])],
        module_id: null,
        taxonomy: null,
        scores: scores,
        orquestion_group_id: null,
        subquestion_parent_id: null,
      }];
      // question paper sub/OR questions have no part in total mark entry
      this.subQuestionParentIds = [];
      this.orquestiongroups = {};
      this.orGroupQuestionIds = {};
      this.updateTotalQuestionScore();
    },

    async getExamParticipants() {
      // absent_enable only exists for students who already have a real participant
      // row (seeded when the exam was created, or from a previous save) - participant
      // rows aren't created just for being listed, only when scores are actually saved
      const absentEnableByStudentId = {};
      const pivotByStudentId = {}; // saved total mark (pivot.score) used by total mark entry
      const participantsUrl =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.examId}/examparticipants?activity_type=${this.exam.activity_type || 'assessment'}`;
      await this.$axios.get(participantsUrl).then((response) => {
        const existingParticipants = response.data.students ?? response.data;
        this.studentListOrder = response.data.student_order || 'roll_number';
        existingParticipants.forEach(participant => {
          absentEnableByStudentId[participant.id] = participant.absent_enable;
          pivotByStudentId[participant.id] = participant.pivot;
        });
      });

      // the roster of every course attached to this activity is the source of truth for
      // who should be listed, regardless of whether a participant row exists yet
      let students = [];
      for (const course of this.exam.course) {
        const courseUrl = `${this.$store.getters.getAPIKey.mainAPI}/courseusersindex?role=2&course=${course.id}`;
        let courseStudents = [];
        await this.$axios.get(courseUrl).then((response) => {
          const data = response.data;
          courseStudents = Array.isArray(data) ? data : (data.users ?? []);
        });
        courseStudents.forEach(courseStudent => {
          students.push({
            id: courseStudent.institution_user_id,
            first_name: courseStudent.first_name,
            last_name: courseStudent.last_name,
            roll_number: courseStudent.roll_number,
            admission_no: courseStudent.admission_no,
            enrollment_no: courseStudent.enrollment_no,
            register_no: courseStudent.register_no,
            section_label: course.usersubgroup.name,
            absent_enable: absentEnableByStudentId[courseStudent.institution_user_id] || false,
            pivot: pivotByStudentId[courseStudent.institution_user_id] || null,
          });
        });
      }

      // group by section so combined classes aren't interleaved, keeping each
      // section's own relative order (e.g. roll number) intact
      const order = [];
      const groups = {};
      students.forEach(student => {
        const key = student.section_label || '';
        if (!groups[key]) { groups[key] = []; order.push(key); }
        groups[key].push(student);
      });
      this.students = order.flatMap(key => groups[key]);
      return this.students;
    },

    isNewSectionGroup(studentIndex) {
      if (studentIndex === 0) return true;
      return this.students[studentIndex].section_label !== this.students[studentIndex - 1].section_label;
    },

    async updateTotalQuestionScore() {

      // add non-or-question scores 
      // find orquestion groups and add score of or question groups and subquestions
      this.totalMarks = 0;
      let orQuestiongroupIds = [];
      await this.questions.forEach((question) => {
        if (question.subquestion_parent_id == null) {
          if (!question.orquestion_group_id) {
            if (this.subQuestionParentIds.includes(question.id)) {
              let subs = this.questions.filter((q) => {
                return `${q.subquestion_parent_id}` == `${question.id}`;
              });
              subs.forEach(subq => {
                this.totalMarks = this.totalMarks + Number(subq.maximum_mark);
              });
            } else {
              this.totalMarks = this.totalMarks + Number(question.maximum_mark);
            }
          } else {
            if (!orQuestiongroupIds.includes(question.orquestion_group_id)) {
              orQuestiongroupIds.push(question.orquestion_group_id);
              let qScore = 0;
              if (this.subQuestionParentIds.includes(question.id)) {
                let subs = this.questions.filter((q) => {
                  return `${q.subquestion_parent_id}` == `${question.id}`;
                });
                subs.forEach(subq => {
                  qScore = qScore + Number(subq.maximum_mark);
                });
              } else {
                qScore = Number(question.maximum_mark);
              }
              qScore =
                qScore *
                Number(
                  this.orquestiongroups[question.orquestion_group_id]
                    .best_of_questions
                );
              this.totalMarks = this.totalMarks + qScore;
            }
          }
        }
      });

    },

    async getExamQuestions() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.examination +
        `/${this.examId}/examquestions`;
      let questionsResponse = [];
      await this.$axios.get(url).then((response) => {
        questionsResponse = response.data;
      });


      // or sub questions manage
      await questionsResponse.forEach((question) => {
        if (question.subquestion_parent_id) {
          if (!this.subQuestionParentIds.includes(question.subquestion_parent_id))
            this.subQuestionParentIds.push(question.subquestion_parent_id);
        }
      });

      let questionArray = [];
      await questionsResponse.forEach((mainQuestion) => {
        if (mainQuestion.subquestion_parent_id == null) {
          // add a normal question to questionArray also its subquestions for currect order
          let tempQuestions = [mainQuestion];

          if (this.subQuestionParentIds.includes(mainQuestion.id)) {
            tempQuestions = questionsResponse.filter((q) => {
              return `${q.subquestion_parent_id}` == `${mainQuestion.id}`;
            });
            tempQuestions.push(mainQuestion);
          }
          tempQuestions.forEach(question => {
            let questionCOs = [];
            question.course_outcome.forEach((co) => {
              questionCOs.push(co.id);
            });
            let participatsQuestionsScore = {};
            this.students.forEach((student) => {
              participatsQuestionsScore[student.id] = null;
              // this.totalScores[student.id] = 0;
            });

            questionArray.push({
              id: question.id,
              question_no: question.question_no,
              name: question.name,
              maximum_mark: question.maximum_mark,
              co_mapping: questionCOs,
              module_id: question.module_id,
              taxonomy: question.blooms_taxonamy_level,
              scores: participatsQuestionsScore,
              orquestion_group_id: question.orquestion_group_id,
              subquestion_parent_id: question.subquestion_parent_id,
            });

            if (question.orquestion_group_id != null) {
              this.orGroupQuestionIds[question.orquestion_group_id].push(question.id);
            }
          });

        }
      });

      this.questions = questionArray;

      this.updateTotalQuestionScore();
    },
    async getExamScores() {
      if (this.isTotalMark) {
        this.fetchData = false;
        return;
      }
      const url =
        this.$store.getters.getAPIKey.examination +
        `/${this.examId}/examanswers`;
      let scores = [];
      await this.$axios.get(url).then((response) => {
        scores = response.data;
      });

      let questionIdKeyMappings = {}; // question index refrerences to access with question id
      await this.questions.forEach((question, questionIndex) => {
        questionIdKeyMappings[question.id] = questionIndex;
      });

      await scores.forEach((score) => {
        let questionsArrayIndex = questionIdKeyMappings[score.examquestion_id];
        if (questionsArrayIndex === undefined) return;
        this.questions[questionsArrayIndex].scores[score.student_id] =
          score.score != null
            ? score.score % 1 == 0
              ? Math.floor(score.score)
              : parseFloat(score.score).toFixed(2)
            : null;
        // this.totalScores[score.student_id] = parseInt(
        //   this.totalScores[score.student_id] + score.score
        // ).toFixed(2);
      });
      this.fetchData = false;
    },
    openManageQuestionWindow() {
      this.enableManageQuestionWindow = true;
    },
    async closeManageQuestionWindow() {
      this.fetchData = true;
      this.enableManageQuestionWindow = false;
      // clear all variables 

      this.fetchData = false;
      this.loadExams = false;
      this.deleteQuestionIndex = null;
      this.questions = [];
      this.courseoutcomesOptions = [];
      this.totalScores = {}; // processed on updateTotalMarks computed proprty
      this.totalMarks = null; // processed on updateTotalQuestionScore method
      this.zIndex = -1;
      this.edit = false;
      this.orquestiongroups = {};
      this.orGroupQuestionIds = {}; // to calculate student totel score 
      this.importExcelFile = null;
      this.excelImportStatus = "";
      this.viewImportExcelModel = false;
      this.expandedEvaluationStudId = null;
      this.activeStudentQuestionsScores = {};//pass to child
      this.autoEvaluationStatus = false;
      this.subQuestionParentIds = [];

      await this.getExamOrQuestionGroups(),
      // await this.getExamOrQuestionGroups();
      await this.getExamQuestions();
      await this.getExamScores();
      await Promise.all([
        this.getCourseOutcomes(),
      ]);
      this.$forceUpdate();
      this.saveBtn = { text: "Save", disabled: false };
      this.fetchData = false;
    },

    async getCourseModules() {
      // this.fetchData = true;
      let courseModuleUrl = this.$store.getters.getAPIKey.getCourseModules;
      const url = courseModuleUrl.replace("course_id", this.exam.course[0].id);
      await this.$axios.get(url).then((response) => {
        let modules = response.data;
        modules.forEach((c_module) => {
          this.$set(
            this.courseModulesOptionsObject,
            c_module.id,
            c_module.module
          );
          this.courseModulesOptions.push({
            value: c_module.id,
            text: c_module.module,
          });
        });
      });
    },
    async getCourseOutcomes() {
      this.courseoutcomesOptions = [];
      let courseModuleUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
      const url = courseModuleUrl.replace("course_id", this.exam.course[0].id);
      let cos = await this.$axios.get(url).then((response) => {
        return response.data;
      });
      let outcomeObjects = {};
      await cos.forEach((outcome) => {
        outcomeObjects[outcome.id] = {
          value: outcome.id,
          name: outcome.code,
        };
        this.courseoutcomesOptions.push(outcomeObjects[outcome.id]);
      });
      await this.questions.forEach((q, index) => {
        let coIds = q.co_mapping;
        let selectedCos = [];
        coIds.forEach((coId) => {
          if (outcomeObjects[coId]) selectedCos.push(outcomeObjects[coId]);
        });
        this.questions[index].co_mapping = selectedCos;
      });
      // this.$forceUpdate();
    },

    async getExamOrQuestionGroups() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/examorquestiongroups?exam_id=${this.examId}`;
      let orquestiongroups = await this.$axios.get(url).then((response) => {
        return response.data;
      });
      this.orquestiongroups = {};
      this.orGroupQuestionIds = {}; // initiate
      await orquestiongroups.forEach((group) => {
        this.orGroupQuestionIds[group.id] = [];
        this.orquestiongroups[group.id] = group;
      });
      this.$forceUpdate();
    },
    async saveQuestionsAndScores(autoUpdateEvent = false) {
      if (this.isTotalMark) return this.saveTotalMarks(autoUpdateEvent);
      this.saveBtn = { text: "saving...", disabled: true };
      let questions_scores = [];
      let participants = [];
      let absentParticipants = [];

      await this.questions.forEach((question) => {
        let course_outcomes = [];
        question.co_mapping.forEach((co) => {
          course_outcomes.push(co.value);
        });
        questions_scores.push({
          id: question.id,
          no: question.question_no,
          maximum_mark: question.maximum_mark,
          course_outcome: course_outcomes,
          blooms_taxonamy_level: question.taxonomy,
          module_id: question.module_id,
          scores: question.scores,
          orquestion_group_id: question.orquestion_group_id,
        });
      });

      await this.students.forEach((student) => {
        participants.push(student.id);
        if (student.absent_enable==1) {
          absentParticipants.push(student.id);
        }
      });
      let postData = {
        participants: participants,
        questions_scores: questions_scores,
        absentParticipants: absentParticipants
      };
      let evaluation = await this.postQuestionAndScore(postData);
      if (evaluation) {
        // await this.prepareTable();
        // await this.getExamScores();
        // await this.getCourseOutcomes();
        this.$forceUpdate();
        if(autoUpdateEvent){
          this.$toast.success("Score updated automatically.");
        }
        else{
          this.$toast.success("Evaluation Successfully done.");
        }
        this.saveBtn = { text: "Save", disabled: false };
        // window.location.reload();
        // await this.getExamQuestions();
        // await this.getExamScores();
      }
      if (!evaluation) {
        return;
      }
    },

    async saveTotalMarks(autoUpdateEvent = false) {
      this.saveBtn = { text: "saving...", disabled: true };
      const totalQuestion = this.questions[0];
      let scores = {};
      let absentParticipants = [];
      this.students.forEach((student) => {
        if (student.absent_enable == 1) absentParticipants.push(student.id);
        const score = totalQuestion.scores[student.id];
        scores[student.id] = score === "" || score === undefined ? null : score;
      });
      const maximumMark = totalQuestion.maximum_mark === "" ? null : totalQuestion.maximum_mark;
      const courseOutcomes = (totalQuestion.co_mapping || [])
        .map((co) => (co && typeof co == "object" ? co.value : co))
        .filter((coId) => coId != null);
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.examId}/examparticipants/totalmarks`;
      let status = false;
      await this.$axios
        .post(url, {
          maximum_mark: maximumMark,
          scores: scores,
          absentParticipants: absentParticipants,
          course_outcome: courseOutcomes,
        })
        .then(() => {
          status = true;
        })
        .catch((error) => {
          this.$toast.error(
            "Something Went Wrong! Please try again! (" +
            error.response.data.message +
            ")"
          );
        });
      this.saveBtn = { text: "Save", disabled: false };
      if (!status) return false;
      this.exam.maximum_mark = maximumMark;
      this.$set(this.exam, "settings", {
        ...(this.exam.settings || {}),
        total_mark_course_outcomes: courseOutcomes,
      });
      this.$forceUpdate();
      this.$toast.success(autoUpdateEvent ? "Score updated automatically." : "Evaluation Successfully done.");
      return true;
    },

    // Post Question Score with API
    async postQuestionAndScore(postData) {
      const url =
        this.$store.getters.getAPIKey.examination +
        `/${this.examId}/questionswithscores`;
      let status = false;
      await this.$axios
        .post(url, postData)
        .then(() => {
          status = true;
        })
        .catch((error) => {
          this.$toast.error(
            "Something Went Wrong! Please try again! (" +
            error.response.data.message +
            ")"
          );
          status = false;
        });
      return status;
    },

    async genarateObjectiveScore() {
      this.autoEvaluationStatus = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/${this.examId}/autoevaluation`;
      await this.$axios.get(url).then(() => {
        return true;
      });
      // await this.prepareTable();
      await this.getExamScores();
      this.$forceUpdate();
      this.autoEvaluationStatus = false;
      this.$toast.success("Evaluation Successfully done.");
    },
  },
};
</script>

<style lang="scss">
// .offlineExam table thead tr:last-child {
//   z-index: none !important;
// }
.offlineExam table {
  width: 100%;
  text-align: center;
}

// .subContentComponentCloseButton{
//   display: none !important;
// }

// input {
//   padding: 0.2rem !important;
// }

// th td {
//   padding: 0.5rem !important;
// }

// table tr:first-child th {
//   position: sticky;
//   top: 0px;
// }
</style>
